// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3dxKk","icon":"SortAdornment_icon__3C3G_","up":"SortAdornment_up__2MZHP","down":"SortAdornment_down__WkXrg","active":"SortAdornment_active__2Pdd_"};